class MCartDrawer extends HTMLElement {
  constructor() {
    super();
    this.cartDrawerInner = this.querySelector(".m-cart-drawer__inner");
    this.cartDrawerCloseIcon = this.querySelector(".m-cart-drawer__close");
    this.cartOverlay = this.querySelector(".m-cart__overlay");
    this.rootUrl = window.Shopify.routes.root;
        this.dynamicCheckout =  this.querySelector("#dynamic-checkout-cart")
       this.currentCountry = document.querySelector(".m-country-switcher [name='country_code']").value
    this.setHeaderCartIconAccessibility();
this.scrollY = 0;
     let loadingTarget = this.cartDrawerInner;
    this.loading = new MinimogLibs.AnimateLoading(loadingTarget, { overlay: loadingTarget });
    this.cartDrawerCloseIcon.addEventListener("click", this.close.bind(this));
    this.addEventListener("click", (event) => {
      if (event.target.closest(".m-cart-drawer__inner") !== this.cartDrawerInner) {
        this.close();

      }
    });

          /* ------------------ VAT CONFIG ------------------ */
    this.VAT_STORAGE_KEY = "vat_mode";
    this.vatCheckbox = this.querySelector("#vat_relief_checkbox");
    

if (this.vatCheckbox) {
  const isUS = this.currentCountry === "GB";

  if (!isUS) {
    // 🔒 Non-US: force EXC
    this.vatCheckbox.checked = true;
    this.vatCheckbox.disabled = true;
    sessionStorage.setItem(this.VAT_STORAGE_KEY, "EXC");
  } else {
    // 🇺🇸 US: restore user preference
    const storedVAT = sessionStorage.getItem(this.VAT_STORAGE_KEY) || "EXC";
    this.vatCheckbox.checked = storedVAT === "EXC";



    this.vatCheckbox.addEventListener("change", async () => {
  sessionStorage.setItem(
    this.VAT_STORAGE_KEY,
    this.vatCheckbox.checked ? "EXC" : "INC"
  );
  await this.cartUpdateWithVAT();
});


  }
}

this.initVatReadMore();
  }


  lockScroll() {
 this.scrollY = window.scrollY;

  document.body.style.position = "fixed";
  document.body.style.top = `-${this.scrollY}px`;
  document.body.style.left = "0";
  document.body.style.right = "0";
  document.body.style.width = "100%";
}

unlockScroll() {
 const top = document.body.style.top;

  document.body.style.position = "";
  document.body.style.top = "";
  document.body.style.left = "";
  document.body.style.right = "";
  document.body.style.width = "";

   window.scrollTo({
    top: Math.abs(parseInt(top || "0")),
    behavior: "instant" // critical
  });
}
initVatReadMore() {
  const textEl = this.querySelector(".vat-relief-box label p");
  const toggleBtn = this.querySelector(".vat-toggle");

  if (!textEl || !toggleBtn) return;

  const fullText = textEl.textContent.trim();
  const words = fullText.split(/\s+/);

  // Hide Read more if text has 10 words or less
  if (words.length <= 15) {
    toggleBtn.style.display = "none";
    return;
  }

  const previewText = words.slice(0, 10).join(" ") + "...";
  let expanded = false;

  // Initial state
  textEl.textContent = previewText;
  toggleBtn.style.display = "inline";
  toggleBtn.textContent = "Read more";

  toggleBtn.addEventListener("click", (e) => {
    e.preventDefault();
    e.stopPropagation();

    expanded = !expanded;

    textEl.textContent = expanded ? fullText : previewText;
    toggleBtn.textContent = expanded ? "Read less" : "Read more";
  });
}
//  async updateCartNote(){
//  this.notefield = this.querySelector(".cart-note-field")
//  const noteField =  this.notefield.value; 
//  console.log("notefield",noteField)
//   if (!noteField) return;

//   try {
//     await fetch('/cart/update.js', {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//         'Accept': 'application/json'
//       },
//       body: JSON.stringify({
//         note: noteField
//       })
//     });
//   } catch (err) {
//     console.error('Cart note update failed', err);
//   }
//  }
  setHeaderCartIconAccessibility() {
    const cartLinks = document.querySelectorAll(".m-cart-icon-bubble");
    cartLinks.forEach((cartLink) => {
      cartLink.setAttribute("role", "button");
      cartLink.setAttribute("aria-haspopup", "dialog");
      cartLink.addEventListener("click", (event) => {
        if (MinimogSettings.enable_cart_drawer) {
          event.preventDefault();
          this.open(cartLink);
        }
      });
    });
  }
getMatchingVariantId(variants, currentVariantId, targetVat) {
  if (!Array.isArray(variants)) return null;

  const current = variants.find(v => Number(v.id) === Number(currentVariantId));
  if (!current) return null;

  const o1 = targetVat;           // VAT
  const o2 = current.option2 || null; // Size
  const o3 = current.option3 || null; // Pack

  const match = variants.find(v => {
    if (v.option1 !== o1) return false;
    if (o2 && v.option2 !== o2) return false;
    if (o3 && v.option3 !== o3) return false;
    return true;
  });

  return match ? match.id : null;
}
async updateCartNoteVATSummary() {
  try {
    const res = await fetch("/cart.js");
    const cart = await res.json();

    let excCount = 0;
    let incCount = 0;
    let naCount = 0;

    cart.items.forEach(item => {
      const opt1 = (item.variant_options?.[0] || "").toUpperCase();

      if (opt1 === "EXC") {
        excCount += item.quantity;
      } else if (opt1 === "INC") {
        incCount += item.quantity;
      } else {
        naCount += item.quantity;
      }
    });

    let parts = [];

    if (excCount > 0) parts.push(`EXC${excCount}`);
    if (incCount > 0) parts.push(`INC${incCount}`);
    if (naCount > 0) parts.push(`NA${naCount}`);

    const note = parts.join(",");

    await fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ note })
    });

  } catch (e) {
    console.error("Failed to update cart note VAT summary:", e);
  }
}



async cartUpdateWithVAT() {
  this.loading.start();

  try {
    if (!this.vatCheckbox) return;

    const targetVAT = this.vatCheckbox.checked ? "EXC" : "INC";
    sessionStorage.setItem(this.VAT_STORAGE_KEY, targetVAT);

    // 👉 Get fresh cart FIRST (critical)
    const cartRes = await fetch("/cart.js");
    const cart = await cartRes.json();

    if (!cart.items.length) {
      this.loading.finish();
      return;
    }

    const updates = {};
    const itemsToAdd = [];

    for (const item of cart.items) {
      const currentVariantId = Number(item.variant_id);
      const qty = Number(item.quantity) || 1;

      const cartItemEl = this.querySelector(
        `.m-cart-item[data-variant-id="${currentVariantId}"]`
      );
      if (!cartItemEl) continue;

      const variantsEl = cartItemEl.querySelector(
        'script[type="application/json"]'
      );
      if (!variantsEl) continue;

      let variants;
      try {
        variants = JSON.parse(variantsEl.textContent);
      } catch {
        continue;
      }

      const newVariantId = this.getMatchingVariantId(
        variants,
        currentVariantId,
        targetVAT
      );

      if (!newVariantId || newVariantId === currentVariantId) continue;

      // 🔥 IMPORTANT: KEEP UPSSELL DISCOUNT
      const lineProperties = item.properties || {};

      updates[currentVariantId] = 0;

      itemsToAdd.push({
        id: newVariantId,
        quantity: qty,
        properties: lineProperties
      });
    }

    const hasUpdates = Object.keys(updates).length > 0;
    const hasAdds = itemsToAdd.length > 0;

    if (hasUpdates) {
      await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ updates })
      });
    }

    if (hasAdds) {
      await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: itemsToAdd , note: targetVAT})
      });
    }

    // 👉 CRITICAL PART — FORCE MINIMOG TO RE-RENDER
    if (hasUpdates || hasAdds) {
      await this.onCartDrawerUpdate();
    }

  } catch (error) {
    console.error("cartUpdateWithVAT failed:", error);
    
  } finally {
     // await new Promise(requestAnimationFrame);

     //await this.updateCartNote()
    this.loading.finish();
  }
}


 async open(triggeredBy) {
    if(window.innerWidth < 768){
      this.lockScroll()
    }
  if (triggeredBy) this.setActiveElement(triggeredBy);

  this.classList.add("m-cart-drawer--active");

  requestAnimationFrame(() => {
    this.style.setProperty("--m-bg-opacity", "0.5");
    this.cartDrawerInner.style.setProperty("--translate-x", "0");
  });

  window.MinimogEvents.emit(MinimogTheme.pubSubEvents.openCartDrawer);
  document.documentElement.classList.add("prevent-scroll");

  await this.cartUpdateWithVAT(); // <-- important
}


  close() {
    if(window.innerWidth < 768){
      this.unlockScroll()
    }
    this.style.setProperty("--m-bg-opacity", "0");
    this.cartDrawerInner.style.setProperty("--translate-x", "100%");
    setTimeout(() => {
      this.classList.remove("m-cart-drawer--active");
      document.documentElement.classList.remove("prevent-scroll");
    }, 300);
  }

  renderContents(parsedState) {
    this.classList.contains("m-cart--empty") && this.classList.remove("m-cart--empty");
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });
    setTimeout(() => {
      this.open();
    });
  }

  updateCartCount(itemCount) {
    const cartCounts = document.querySelectorAll(".m-cart-count-bubble");
    cartCounts.forEach((cartCount) => {
      if (itemCount > 0) {
        cartCount.textContent = itemCount;
        cartCount.classList.remove("m:hidden");
      } else {
        cartCount.classList.add("m:hidden");
      }
    });
  }

  getCart() {
    return fetchJSON(this.rootUrl + "cart.json");
  }

  // onCartDrawerUpdate(updateFooter = true) {
  //   fetch(`${MinimogSettings.routes.cart}?section_id=cart-drawer`)
  //     .then((response) => response.text())
  //     .then((responseText) => {
  //       this.getSectionsToRender().forEach((section) => {
  //         if (section.block === "cart-items") {
  //           const sectionElement = section.selector
  //             ? document.querySelector(section.selector)
  //             : document.getElementById(section.id);
  //           sectionElement.innerHTML = this.getSectionInnerHTML(responseText, section.selector);
  //         } else {
  //           if (updateFooter) {
  //             const sectionElement = section.selector
  //               ? document.querySelector(section.selector)
  //               : document.getElementById(section.id);
  //             sectionElement.innerHTML = this.getSectionInnerHTML(responseText, section.selector);
  //           }
  //         }
  //       });
  //     })
  //     .catch((e) => {
  //       console.error(e);
  //     });
  //   this.getCart().then((cart) => {
  //     this.classList.toggle("m-cart--empty", cart.item_count === 0);
  //     this.updateCartCount(cart.item_count);
  //   });

  // }

  async onCartDrawerUpdate(updateFooter = true) {
  const response = await fetch(
    `${MinimogSettings.routes.cart}?section_id=cart-drawer`
  );

  const responseText = await response.text();

  this.getSectionsToRender().forEach((section) => {
    const sectionElement = section.selector
      ? document.querySelector(section.selector)
      : document.getElementById(section.id);

    if (sectionElement) {
      sectionElement.innerHTML =
        this.getSectionInnerHTML(responseText, section.selector);
    }
  });

  const cart = await this.getCart();
  this.classList.toggle("m-cart--empty", cart.item_count === 0);
  this.updateCartCount(cart.item_count);

  // ⭐ VERY IMPORTANT — wait one frame so browser paints
  await new Promise(requestAnimationFrame);
}

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser().parseFromString(html, "text/html").querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "[data-minimog-cart-items]",
        block: "cart-items",
      },
      {
        id: "cart-drawer",
        selector: "[data-minimog-cart-discounts]",
        block: "cart-footer",
      },
      {
        id: "cart-drawer",
        selector: "[data-cart-subtotal]",
        block: "cart-footer",
      },
      {
        id: "cart-drawer",
        selector: "[data-minimog-gift-wrapping]",
        block: "cart-footer",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser().parseFromString(html, "text/html").querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("m-cart-drawer", MCartDrawer);

class MCartDrawerItems extends MCartTemplate {
  getSectionsToRender() {
    return [
      {
        id: "MinimogCartDrawer",
        section: "cart-drawer",
        selector: "[data-minimog-cart-items]",
      },
      {
        id: "MinimogCartDrawer",
        section: "cart-drawer",
        selector: "[data-minimog-cart-discounts]",
      },
      {
        id: "MinimogCartDrawer",
        section: "cart-drawer",
        selector: "[data-cart-subtotal]",
      },
      {
        id: "MinimogCartDrawer",
        section: "cart-drawer",
        selector: "[data-minimog-gift-wrapping]",
      },
    ];
  }
}

customElements.define("m-cart-drawer-items", MCartDrawerItems);
